<template>
  <div class="card-stats">
    <div class="card-stats-title">
      <img :src="logo" alt="people" />
      <p>{{ title }}</p>
    </div>
    <h3 class="card-stats-number">
      <span v-if="naira">₦ </span>{{ number.toLocaleString() }}
    </h3>
    <p class="card-stats-percentage">{{ percentage }}</p>
  </div>
</template>

<script>
import { type } from "jquery";

export default {
  name: "SummaryCard",
  props: {
    logo: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
      required: true,
    },
    number: {
      type: Number,
      default: "",
      required: true,
    },
    percentage: {
      type: String,
      default: "",
      required: false,
    },
    naira: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style>
.card-stats {
  background: white;
  border: 1px solid #ced3dd;
  border-radius: 10px;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 180px;
}

.card-stats-title {
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 10px;
}

.card-stats-title p {
  margin: 0;
  color: #070a2c;
  font-weight: 600;
}

.card-stats-number {
  margin: 0;
  font-size: 24px;
  color: #23242f;
  font-weight: 700;
}

.card-stats-percentage {
  margin: 0;
  font-size: 14px;
  color: #6a6c88;
  font-weight: 600;
}
</style>
